import { useState,useEffect,useRef } from "react";
import axios from "axios";

import ClientSelector from "../Client/ClientSelector";
import TechnicianSelector from "../Technician/TechnicianSelector";
import ManagerSelector from "../Manager/ManagerSelector";

function AddTicket({ onClose }) {

const [clientId,setClientId]=useState("");
const [clientName,setClientName]=useState("");

const [technicianId,setTechnicianId]=useState("");
const [technicianName,setTechnicianName]=useState("");

const [managerId,setManagerId]=useState("");
const [managerName,setManagerName]=useState("");

const [title,setTitle]=useState("");
const [description,setDescription]=useState("");

const [priority,setPriority]=useState("Medium");

const [showClientPopup,setShowClientPopup]=useState(false);

const [showTechnicianPopup,
setShowTechnicianPopup]=useState(false);

const [showManagerPopup,
setShowManagerPopup]=useState(false);

const clientInputRef=useRef(null);

const technicianInputRef=useRef(null);

const managerInputRef=useRef(null);

useEffect(()=>{

setTimeout(()=>{

clientInputRef.current?.focus();

},100);

},[]);

const clearForm=()=>{

setClientId("");
setClientName("");

setTechnicianId("");
setTechnicianName("");

setManagerId("");
setManagerName("");

setTitle("");
setDescription("");

setPriority("Medium");

};

const saveTicket=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=
await axios.post(

"https://saleupcall.com/api/Ticket/add-ticket-admin.php",

{
client_id:clientId,
technician_id:technicianId || null,
manager_id:managerId || null,
title:title,
description:description,
priority:priority
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

console.log(response.data);

if(response.data.status){

alert(

"Ticket Created : " +
response.data.ticket_number

);

clearForm();

if(onClose){

onClose();

}

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

alert(
"Error creating ticket"
);

}

};

return(

<>

<div className="container-fluid p-3">

<div className="card-body">

<form onSubmit={saveTicket}>

<div className="mb-3">

<label className="form-label">

Client

</label>

<input

ref={clientInputRef}

type="text"

className="form-control"

placeholder="Select Client"

value={clientName}

onChange={()=>{}}

onClick={()=>
setShowClientPopup(true)
}

onKeyDown={(e)=>{

if(e.key==="Enter"){

e.preventDefault();

setShowClientPopup(true);

}

}}

required

/>

</div>

<div className="mb-3">

<label className="form-label">

Manager

</label>

<input

ref={managerInputRef}

type="text"

className="form-control"

placeholder="Select Manager"

value={managerName}

onChange={()=>{}}

onClick={()=>
setShowManagerPopup(true)
}

onKeyDown={(e)=>{

if(e.key==="Enter"){

e.preventDefault();

setShowManagerPopup(true);

}

}}

/>

</div>

<div className="mb-3">

<label className="form-label">

Technician

</label>

<input

ref={technicianInputRef}

type="text"

className="form-control"

placeholder="Select Technician"

value={technicianName}

onChange={()=>{}}

onClick={()=>
setShowTechnicianPopup(true)
}

onKeyDown={(e)=>{

if(e.key==="Enter"){

e.preventDefault();

setShowTechnicianPopup(true);

}

}}

/>

</div>

<div className="mb-3">

<label className="form-label">

Title

</label>

<input

type="text"

className="form-control"

placeholder="Enter Title"

value={title}

onChange={(e)=>
setTitle(
e.target.value
)
}

required

/>

</div>

<div className="mb-3">

<label className="form-label">

Description

</label>

<textarea

className="form-control"

placeholder="Enter Description"

rows="5"

value={description}

onChange={(e)=>
setDescription(
e.target.value
)
}

required

/>

</div>

<div className="mb-3">

<label className="form-label">

Priority

</label>

<select

className="form-select"

value={priority}

onChange={(e)=>
setPriority(
e.target.value
)
}

>

<option value="Low">

Low

</option>

<option value="Medium">

Medium

</option>

<option value="High">

High

</option>

<option value="Critical">

Critical

</option>

</select>

</div>

<div className="d-flex justify-content-end gap-2">

<button

type="button"

className="btn btn-secondary"

onClick={clearForm}

>

Cancel

</button>

<button

type="submit"

className="btn btn-success"

>

Create Ticket

</button>

</div>

</form>

</div>

</div>

{
showClientPopup && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Select Client</h5>

<button
className="btn-close"
onClick={()=>
setShowClientPopup(false)
}
>
</button>

</div>

<div className="modal-body">

<ClientSelector

onSelect={(client)=>{

setClientId(client.id);

setClientName(client.name);

setShowClientPopup(false);

}}

/>

</div>

</div>

</div>

</div>

)

}

{
showTechnicianPopup && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Select Technician</h5>

<button
className="btn-close"
onClick={()=>
setShowTechnicianPopup(false)
}
>
</button>

</div>

<div className="modal-body">

<TechnicianSelector

onSelect={(technician)=>{

setTechnicianId(
technician.id
);

setTechnicianName(
technician.name
);

setShowTechnicianPopup(false);

}}

/>

</div>

</div>

</div>

</div>

)

}

{
showManagerPopup && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Select Manager</h5>

<button
className="btn-close"
onClick={()=>
setShowManagerPopup(false)
}
>
</button>

</div>

<div className="modal-body">

<ManagerSelector

onSelect={(manager)=>{

setManagerId(manager.id);

setManagerName(manager.name);

setShowManagerPopup(false);

}}

/>

</div>

</div>

</div>

</div>

)

}

</>

);

}

export default AddTicket;
